export default "__VITE_PUBLIC_ASSET__06575126__"